// src/features/fourlink-config/components/forms/CentroForm.jsx

import React, { useState } from 'react';

export const CentroForm = ({ 
  selectedTipologias, 
  centros, 
  onAddCentro, 
  onDeleteCentro 
}) => {
  const [newCentroName, setNewCentroName] = useState('');
  const [newCentroTipologia, setNewCentroTipologia] = useState('');

  const handleAddCentro = () => {
    if (newCentroName.trim() && newCentroTipologia) {
      onAddCentro({
        id: Date.now(),
        name: newCentroName.trim(),
        tipologia: newCentroTipologia
      });
      setNewCentroName('');
      setNewCentroTipologia('');
    }
  };

  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h4 className="font-medium text-gray-700 mb-3">Agregar Centro Individual</h4>
      <div className="flex gap-3 mb-4">
        <input
          type="text"
          placeholder="Nombre del centro"
          value={newCentroName}
          onChange={(e) => setNewCentroName(e.target.value)}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <select
          value={newCentroTipologia}
          onChange={(e) => setNewCentroTipologia(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="">Selecciona tipología</option>
          {selectedTipologias.map(tipologia => (
            <option key={tipologia} value={tipologia}>{tipologia}</option>
          ))}
        </select>
        <button
          onClick={handleAddCentro}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          Agregar
        </button>
      </div>

      {centros.length > 0 && (
        <div className="space-y-2">
          <h4 className="font-medium text-gray-700">Centros configurados:</h4>
          <div className="max-h-60 overflow-y-auto">
            {centros.map(centro => (
              <div key={centro.id} className="flex items-center justify-between bg-white p-3 rounded border">
                <div>
                  <span className="font-medium">{centro.name}</span>
                  <span className="text-gray-500 ml-2">({centro.tipologia})</span>
                </div>
                <button
                  onClick={() => onDeleteCentro(centro.id)}
                  className="text-red-500 hover:text-red-700 p-1"
                >
                  x
                </button>
              </div>
            ))}
          </div>
          
          <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded">
            <p className="text-sm font-medium text-blue-800 mb-2">Resumen por tipología:</p>
            {selectedTipologias.map(tipologia => {
              const count = centros.filter(c => c.tipologia === tipologia).length;
              return (
                <div key={tipologia} className="flex justify-between text-sm text-blue-700">
                  <span>{tipologia}:</span>
                  <span className="font-medium">{count} centro{count !== 1 ? 's' : ''}</span>
                </div>
              );
            })}
            <div className="border-t border-blue-200 mt-2 pt-2 flex justify-between text-sm font-bold text-blue-800">
              <span>Total:</span>
              <span>{centros.length} centro{centros.length !== 1 ? 's' : ''}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};